/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * PID Simulations request payload
 * @export
 * @interface PidSimulationValidationRequest
 */
export interface PidSimulationValidationRequest {
    /**
     * 
     * @type {string}
     * @memberof PidSimulationValidationRequest
     */
    simulationId?: string;
    /**
     * 
     * @type {number}
     * @memberof PidSimulationValidationRequest
     */
    invoiceId?: number;
}

/**
 * Check if a given object implements the PidSimulationValidationRequest interface.
 */
export function instanceOfPidSimulationValidationRequest(value: object): value is PidSimulationValidationRequest {
    return true;
}

export function PidSimulationValidationRequestFromJSON(json: any): PidSimulationValidationRequest {
    return PidSimulationValidationRequestFromJSONTyped(json, false);
}

export function PidSimulationValidationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PidSimulationValidationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'simulationId': json['simulationId'] == null ? undefined : json['simulationId'],
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
    };
}

export function PidSimulationValidationRequestToJSON(json: any): PidSimulationValidationRequest {
    return PidSimulationValidationRequestToJSONTyped(json, false);
}

export function PidSimulationValidationRequestToJSONTyped(value?: PidSimulationValidationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'simulationId': value['simulationId'],
        'invoiceId': value['invoiceId'],
    };
}

